import React, { createContext, useContext, ReactNode } from "react";
import { useGetSingleLocationQuery } from "../../../services/api/locationsApi";
import { useLocalSearchParams } from "expo-router";
import { LocationModel } from "app/services/api/types/authorisation/models/LocationModel";

interface LocationContextType {
  location: LocationModel | undefined;
  locationId: number;
  isLoading: boolean;
  error?: any;
  refetch: () => void;
}

const LocationContext = createContext<LocationContextType | undefined>(
  undefined,
);

interface LocationProviderProps {
  children: ReactNode;
  locationId?: number;
}

export function LocationProvider({
  children,
  locationId: propLocationId,
}: LocationProviderProps) {
  const paramsLocationId = Number(useLocalSearchParams().id);
  const locationId = propLocationId || paramsLocationId;

  const { data, isLoading, error, refetch } = useGetSingleLocationQuery({
    location: locationId,
  });

  const contextValue: LocationContextType = {
    location: data,
    locationId,
    isLoading,
    error,
    refetch,
  };

  return (
    <LocationContext.Provider value={contextValue}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  const context = useContext(LocationContext);
  if (context === undefined) {
    throw new Error("useLocation must be used within a LocationProvider");
  }
  return context;
}
